import { render, staticRenderFns } from "./SubmitClaimSummary.vue?vue&type=template&id=81528988"
import script from "./SubmitClaimSummary.vue?vue&type=script&lang=js"
export * from "./SubmitClaimSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports